export enum Method {
  Get = 'GET',
  Post = 'POST',
  Put = 'PUT',
  Delete = 'DELETE',
  Patch = 'PATCH',
}

export const MainArchive = 'Main Archive';

export const ReactUINodes = {
  Select: 'select',
  Toggle: 'toggle',
};
